<template>
  <!-- Toast -->
  <transition name="toast" class="toast-leave-active">
    <Toast ref="toaster" v-if="toast.show" v-bind:class="{ 'toast-wrapper' : true }" :text="toast.text"/>
  </transition>

  <!-- "Favorites" data list -->
  <div v-if="toggle" class="favCities">
    <div class="row">
      <!--  CSV export  -->
      <div class="w-100 text-end p-3">
        <button :disabled="isDisabled" class="CSVButton p-2" @click="download" type="submit">
          <i class="fa-solid fa-download pe-3" v-if="downloading === false"></i>
          <i class="fa-solid fa-spinner me-3 " v-if="downloading === true"></i>
          &nbsp;Export to CSV
        </button>
      </div>
      <!-- End of export    -->
      <div class="col-4" v-for="(name, index, id) in favoriteCities" :key="id" >
        <h5 class="py-2">{{ index }}</h5>
        <ul>
          <li v-for="city in name">
            <button id="copyButton" v-clipboard="city.geonameId" @click="toast.trigger('ID has been copied!')" title="Click to copy ID">
              <i class="fa-regular fa-copy"></i>
            </button>
            <span class="ps-1">ID: {{ city.geonameId}} ({{ city.name }})</span>
            <button @click="removeFavorite(city.geonameId, city.name)" class="removeButton" title="Click to remove city from favorites list">
              <i class="fa-solid fa-minus align-middle"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import Toast from "../Toast";

export default {
  components: {
    Toast,
  },
  props: [
    'toggle',
  ],
  setup() {},
  data() {
      return {
        downloading: false,
        isDisabled:false,
        favoriteCities: {},
        toast: {
          text: '',
          show: false,
          trigger: (text) => {
            this.toast.text = text;
            this.toast.show = true;

            setTimeout(() => {
              this.toast.show = false;
            }, 3000);
          }
        }
      }
  },
  mounted() {
    this.getFavorites();
  },
  methods: {
    download() {
      this.startDownloading();

      // Prepare data
      let CSVData = '';

      for (const item of Object.entries(this.favoriteCities)) {
        for (const item2 of Object.entries(item[1])) {
          const itemData = item2[1];
          CSVData += itemData.geonameId + ';' + itemData.name + ';' + itemData.countryName + '\n';
        }
      }
      const text = 'ID; Name; Country\n'+ CSVData;

      // Trigger download
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', 'favorite_cities.csv');

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();
      element.remove();

      this.stopDownloading();
    },

    async removeFavorite(geonameid, name) {
      const _this = this;

      if (! confirm('Are you sure you want to remove ' + name + ' from your favorites list?')) {
        return;
      }

      await axios.post('http://demo.api.coin-dev.eu/api/v1/en/rest/utilities/cities-favorites/remove', { geonameid })
        .then(function (response) {
          // console.log(response);
          _this.toast.trigger('City has been successfully removed from favorites.');
        })
        .catch(function (error) {
          _this.toast.trigger('Something went wrong. Contact us if the problem persists.');
          console.error(error);
        });

      this.getFavorites();
    },
    getFavorites() {
      const _this = this;
      axios.get('http://demo.api.coin-dev.eu/api/v1/en/rest/utilities/cities-favorites')
          .then(response => {
            this.favoriteCities = response.data.data;
          })
          .catch(err => {
            _this.toast.trigger('Something went wrong. Contact us if the problem persists.');
            console.error(err);
          });
    },
    stopDownloading() {
      this.downloading = false;
      this.isDisabled = false;
    },
    startDownloading() {
      this.downloading = true;
      this.isDisabled = true
    }
  }
}
</script>

<style lang="scss">
@import "favorite-block";
</style>